import axios from "../../axios";

const createAdministrator = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('admin/administration/createAdministrator', data , {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createAdministrator;
